export default __webpack_public_path__ + "static/media/pvilla1-4.796d1f6c.webp";